import React from "react";
import styles from "../BrandOfTheMonthModal.module.scss";
import Spinner from "../../../../utils/loader/Spinner";
import {useCustomerContext} from "../../../../customer/CustomerContextProvider/CustomerContextProvider";
import {useTranslation} from "react-i18next";
import {useForm} from "react-hook-form";
import {emailRegExp} from "../../../../lib/ModalWindow/ForgotPasswordModal";
import window from "../../../../lib/WindowExtended";

type FormState = {
  email: string;
};

const MagicLinkForm: React.FC<{onEmailSent: (email: string) => void}> = ({onEmailSent}) => {
  const {customer} = useCustomerContext();
  const {t} = useTranslation(["checkout", "customerAccount"]);
  const {
    formState: {errors, isSubmitting},
    register,
    handleSubmit,
  } = useForm<FormState>({mode: "onSubmit", defaultValues: {email: customer.email ?? ""}});

  const onSubmit = (data: FormState) => {
    const {email} = data;

    if (Object.keys(errors).length !== 0) {
      return;
    }

    const {origin, pathname, search} = window.location;
    const usp = new URLSearchParams(search);
    const redirectUrl = origin + pathname + (usp.toString() ? "?" + usp.toString() : "");

    return customer.requestMagicLink(email, redirectUrl).then(() => {
      onEmailSent(email);
    });
  };

  return (
    <form className={styles.bomForm} noValidate onSubmit={handleSubmit(onSubmit)}>
      <input
        type="email"
        placeholder={t("Ihre Newsletter-E-Mail-Adresse")}
        className={errors.email ? styles.invalid : ""}
        {...register("email", {
          required: t<string>("Bitte ausfüllen"),
          pattern: {value: emailRegExp, message: t<string>("Bitte geben Sie eine gültige E-Mail-Adresse an")},
        })}
      />
      {errors.email && <span className={styles.errorMessageInput}>{errors.email.message}</span>}
      <button type="submit">{isSubmitting ? <Spinner /> : <>{t("Loginlink anfordern")}</>}</button>
    </form>
  );
};

export default MagicLinkForm;
